import { render, staticRenderFns } from "./MenuMain.vue?vue&type=template&id=1e420e25&"
import script from "./MenuMain.vue?vue&type=script&lang=js&"
export * from "./MenuMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports